export const email = 'info@gsinfotechwebsolutions.com'
// all phone number 
export const phone_number = ' 9965600082'
// export const phone_number2 = 'xxxxxxxxxx'
// export const phone_number3 = 'xxxxxxxxxx'
// export const phone_number4 = '99141-22229'

// address detail...
export const main_address = 'Ground Floor, Sarv Elanza, Near DAV Collage, Opp. Roll Express ,Abohar, Punjab 152116'
// export const first_address = 'E281 - Second Floor , GM Tower, Industrial Area, Sector 75, Sahibzada Ajit Singh Nagar, Punjab 140308'
// export const second_address = 'Shop No.206, Creation Plaza-1, Puna, to, Bombay Market-Punagam Rd, Surat, Gujarat 395001'




